import { cloneDeep } from "lodash";

import BaseCommand from "./baseCommand";

class SignatureTypeChangeCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  execute() {
    const {
      data,
      event,
      signerIndex,
      setState,
      onSectionUpdate,
    } = this.componentData;
    const newData = cloneDeep(data);
    newData[signerIndex].signer_config.signature_type = event;
    setState({ signBlocks: newData });

    const dontDeleteNameField = true;
    onSectionUpdate(newData[signerIndex], false, newData, dontDeleteNameField);
  }

  undo() {
    const { data, setState, onSectionUpdate, signerIndex } = this.componentData;
    setState({ signBlocks: data });
    onSectionUpdate(data[signerIndex], false, data);
  }
}

export default SignatureTypeChangeCommand;



// WEBPACK FOOTER //
// ./src/commands/signatureTypeChangeCommand.js